import { SubjectEntity } from '../enums/ability-entity.enum';

export class AccountDto {

    public static __caslSubjectType__ = SubjectEntity.ORG;

    public static fromApiResponse(fields: Partial<AccountDto>): AccountDto {
        const dto = new AccountDto();

        Object.assign(dto, fields);

        return dto;
    }

    public readonly id: number;
    public name: string;
    public status: string = 'ACTIVE';
    public statusId: number = 1;
    public flags: string[] = [];
    public keywords: string[] = [];

    public vapidPrivateKey: string;
    public vapidPublicKey: string;
    public senderId: string;
    public fcmServerKey: string;
    public fcmCredentialsUploaded: boolean;
    public timezone: string;
    public defaultNotificationLandingUrl: string;
    public defaultNotificationTtlSeconds: number;
    public addedNotificationQueryParams: any;
    public utmParams: any;
    public globalPromptSettings: any;
    public frequencyCaps: any;
    public mediaQuality: number;

    public collapseKeyType: string;
    public routingKey: string;
    public billingData: any;
    public displayMeta: any;

    public createdBy: number;
    public createdAt: Date;
    public createdByUserName: string;
    public updatedBy: number;
    public updatedAt: Date;
    public updatedByUserName: string;

    public domains: any[];
    public getDomainCount(): number {
        return (this.domains || []).length;
    }

}
